import { Model } from '@/services/api/lib'

export class Payment extends Model {
  resource () {
    return 'payments'
  }

  capture (authorizationId) {
    return this.request({
      method: 'POST',
      url: `${this.endpoint()}/v1/authorizations/${authorizationId}/capture`
    })
  }
}
